import React from 'react';

import { Container, Row, Col } from 'react-bootstrap';
import { FaPlay } from 'react-icons/fa';
import { MdEventNote } from 'react-icons/md';
import { BiUserCheck } from 'react-icons/bi';
import { RiTeamLine } from 'react-icons/ri';
import { AiOutlineProject } from 'react-icons/ai';
import '../../../assets/css/customer/services/FeaturesSection.css';

const FeaturesSection = () => {
   
  
  const features = [
    {
      id: 1,
      icon: <MdEventNote />,
      title: 'Customized Planning',
      description: 'Create your perfect wedding plan with personalized options tailored to your style, budget, and preferences.'
    },
    {
      id: 2,
      icon: <BiUserCheck />,
      title: 'Experienced Professional',
      description: 'Connect with trusted vendors and experienced professionals to ensure your event runs smoothly and beautifully.'
    },
    {
      id: 3,
      icon: <RiTeamLine />,
      title: 'Vendor Management:',
      description: 'Easily manage and communicate with multiple vendors in one place without any hassle.'
    },
    {
      id: 4,
      icon: <AiOutlineProject />,
      title: 'Timeline Creation',
      description: 'Stay organized with a clear event timeline that keeps every task and schedule on track.'
    }
  ];

  return (
    <section className="features-section">
      <Container>
        <Row className="align-items-center">
          
          {/* Left Column - Content */}
          <Col lg={5} md={12} className="features-left-col">
            <div className="features-content">
              
              {/* Decorative Icon */}
              <div className="features-decorative-icon">
                <span className="decorative-bird">🕊️</span>
                <span className="decorative-heart">💗</span>
              </div>

              {/* Subtitle */}
              <p className="features-subtitle">Personalized Planning Services</p>

              {/* Main Heading */}
              <h2 className="features-main-heading">
                Smart Features for Your Wedding & Event Planning
              </h2>

              {/* Description */}
              <p className="features-description">
                Easily plan and manage your wedding with our smart and user-friendly event management system.
              </p>

              {/* Watch Video Button */}
              <button className="features-watch-video-btn">
                <span className="video-icon-wrapper">
                  <FaPlay className="play-icon" />
                </span>
                <span className="video-text">WATCH VIDEO</span>
              </button>

            </div>
          </Col>

          {/* Right Column - Feature Cards */}
          <Col lg={7} md={12} className="features-right-col">
            <Row className="features-cards-row">
              {features.map((feature) => (
                <Col lg={6} md={6} sm={12} key={feature.id} className="mb-4">
                  <div className="feature-card">
                    
                    {/* Icon */}
                    <div className="feature-icon-wrapper">
                      {feature.icon}
                    </div>

                    {/* Title */}
                    <h4 className="feature-title">{feature.title}</h4>

                    {/* Description */}
                    <p className="feature-description">{feature.description}</p>

                  </div>
                </Col>
              ))}
            </Row>
          </Col>

        </Row>
      </Container>

      
    </section>
  );
};

export default FeaturesSection;